import { z } from 'zod'
import { ChangeId, IsActive, ObjectId, ObjectUuid } from './common-schemas'
import { GarItem } from './gar-item'

export namespace RegistryObjectsItem {
  export interface Data {
    /** @description Unique identifier of the address object */
    readonly objectId: number

    /** @description Global unique identifier of the address object */
    readonly objectGuid: string

    /** @description Identifier of the changing transaction */
    readonly changeId: number

    /** @description Active object indicator */
    readonly isActive: boolean

    /** @description Object level */
    readonly levelId: number

    /** @description Creation date */
    readonly createDate: Date

    /** @description Modification date */
    readonly updateDate: Date
  }
}

/** @description Information on registry element */
export class RegistryObjectsItem extends GarItem<
  'RegistryObjectsItem',
  RegistryObjectsItem.Data
> {
  static readonly SCHEMA: GarItem.Schema<RegistryObjectsItem.Data> = z
    .strictObject({
      OBJECTID: ObjectId,

      OBJECTGUID: ObjectUuid,

      CHANGEID: ChangeId,

      ISACTIVE: IsActive,

      LEVELID: z.coerce.number<string>().int().describe('Object level'),

      CREATEDATE: z.coerce.date<string>().describe('Creation date'),

      UPDATEDATE: z.coerce.date<string>().describe('Update date'),
    })
    .transform<RegistryObjectsItem.Data>(attributes => ({
      objectId: attributes.OBJECTID,
      objectGuid: attributes.OBJECTGUID,
      changeId: attributes.CHANGEID,
      isActive: attributes.ISACTIVE,
      levelId: attributes.LEVELID,
      createDate: attributes.CREATEDATE,
      updateDate: attributes.UPDATEDATE,
    }))

  readonly type = 'RegistryObjectsItem'

  protected get schema() {
    return RegistryObjectsItem.SCHEMA
  }
}
